var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageTitle'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('ChangePassword')],1),_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('Sessions')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }